<a class="pointer" (click)="navigateToEntity(params);$event.stopPropagation()">
    {{params.value}}
</a>